export const convertHexStringToNumArray = (hex: string) => {
  hex = hex.replace(/#/g, '');
  const hexArray = hex.match(/.{2}/g) ?? [];
  return hexArray?.map(color => parseInt(color, 16));
};
